export default __webpack_public_path__ + "static/media/image.c4b61806.svg";